import { createSlice } from '@reduxjs/toolkit'
import { createActions } from "@helper"
import * as actions from '../action'

const initialState = {
    goods: {}, // 商品基本属性
    extendAttrs: [], // 额外属性,
    categoryGroupList: [], // 类目列表
    goodsImage: [], // 图片列表
    goodsVideo: [], // 视频列表
    skuList: [], // sku列表
    itemCodeList: [],
    salesAttrs: [],
    memberBuyingPriorityConfig: {},
    itemGoodsColorList: [],
    memberLevelMap: {}
}

const reducers = createActions({
    getGoodsDetailAction: {
        success: (state, action) => {
            const {
                goods= {}, // 商品基本属性
	            extendAttrs= [], // 额外属性,
	            categoryGroupList= [], // 类目列表
	            goodsImage= [], // 图片列表
	            goodsVideo= [], // 视频列表
	            skuList= [], // sku列表
	            itemCodeList= [],
	            salesAttrs= [],
	            memberBuyingPriorityConfig= {},
	            itemGoodsColorList= []
            } = action.payload || {}
	        
            return {
                ...state,
	            goods,
	            extendAttrs,
	            categoryGroupList,
	            goodsImage,
	            goodsVideo,
	            skuList,
	            itemCodeList,
	            salesAttrs,
	            memberBuyingPriorityConfig,
	            itemGoodsColorList
            }
        }
    },
    getMemberLevelListAction: {
        success: (state, action) => {
            const obj = action.payload?.reduce((acc, cur) => {
                acc[cur.memberLevelCode] = cur
	            return acc
            }, {})
            return {
                ...state,
                memberLevelMap: obj
            }
        }
    }
}, actions)

const goodsSlice = createSlice({
    name: 'goodsDetail',
    initialState,
    ...reducers
})

export default goodsSlice
